import axios from 'axios';

import { IKiosqueVisite } from '@/shared/model/kiosque-visite.model';

const baseApiUrl = 'api/kiosque-visites';

export default class KiosqueVisiteService {
  public find(id: number): Promise<IKiosqueVisite> {
    return new Promise<IKiosqueVisite>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IKiosqueVisite): Promise<IKiosqueVisite> {
    return new Promise<IKiosqueVisite>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IKiosqueVisite): Promise<IKiosqueVisite> {
    return new Promise<IKiosqueVisite>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
